import { Card, CardBody, Col, Row } from "reactstrap";
import { useLocation } from "react-router-dom";

const UpgradeSuccessContainer = () => {
  const location = useLocation();
  const {
    upgradeId = "SSC00001",
    pin = "4681P0824",
    paidBy = "Sukanya Swastik Care",
    upgradeDate = new Date().toLocaleString(),
  } = location.state || {};

  return (
    <Row
      className="justify-content-center align-items-center"
      style={{ minHeight: "70vh" }}
    >
      <Col md="10" xl="8">
        <Card
          className="p-4 shadow-sm"
          style={{ borderRadius: "12px", border: "none" }}
        >
          {/* Header */}
          <div
            className="p-3 mb-4"
            style={{
              backgroundColor: "#fdf6e3",
              borderRadius: "8px",
              fontWeight: 600,
              fontSize: "1.25rem",
              color: "#5a4636",
            }}
          >
            Upgrade Success Details
          </div>

          <CardBody className="text-center">
            {/* Success Icon */}
            <div className="mb-3">
              <i
                className="fa fa-check-circle"
                style={{ fontSize: "4rem", color: "#36c5f0" }}
              />
            </div>

            {/* Main Success Message */}
            <h4 className="fw-bold mb-1">Process Completed Successfully!</h4>
            <p className="text-muted mb-4">Thank you</p>

            {/* Details Section */}
            <div
              className="mx-auto"
              style={{
                borderTop: "1px solid #eee",
                borderBottom: "1px solid #eee",
                padding: "20px 10px",
                maxWidth: "450px",
              }}
            >
              <div
                style={{
                  textAlign: "left",
                  fontSize: "0.95rem",
                  lineHeight: "1.8",
                }}
              >
                <p className="mb-1">
                  <strong>Upgrade Id:</strong> {upgradeId}
                </p>
                <p className="mb-1">
                  <strong>PIN:</strong> {pin}
                </p>
                <p className="mb-1">
                  <strong>Paid BY:</strong> {paidBy}
                </p>
                <p className="mb-0">
                  <strong>Upgrade Date:</strong> {upgradeDate}
                </p>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default UpgradeSuccessContainer;
